export function urlJoin(...urls: string[]): string {
  let finalURL = "";
  for (const relURL of urls) {
    if (finalURL.length === 0) {
      finalURL = relURL;
    } else if (relURL.length > 0) {
      if (finalURL[finalURL.length - 1] !== "/") {
        finalURL += "/"; // Add bar at end
      }
      if (relURL[relURL.length - 1] === "/") {
        finalURL += relURL.substring(1); // Remove first char
      } else {
        finalURL += relURL;
      }
    }
  }
  return finalURL;
}

export function addQueryToURL(baseURL: string, paramName: string, paramValue: string): string {
  let url = baseURL;
  url += url.lastIndexOf("?") > 0 ? "&" : "?";
  url += `${paramName}=${paramValue}`;
  return url;
}
